module.exports = __webpack_public_path__ + "img/Corona_borealis.78f42862.png";